import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'bytes',
  standalone: true
})
export class BytesPipe implements PipeTransform {
  transform(value: number, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '0 B';
    if (value === 0) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(value) / Math.log(k));
    const size = parseFloat((value / Math.pow(k, i)).toFixed(dm));

    return `${size} ${sizes[i]}`;
  }
}
